var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('StaticStringInjector',{attrs:{"string":_vm.placeholder},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var string = ref.string;
return [_c('Multiselect',{attrs:{"value":_vm.value,"options":_vm.options,"searchable":true,"allowEmpty":true,"multiple":true,"placeholder":string,"showLabels":false},on:{"input":function($event){return _vm.$emit('input', $event)}}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }